import React from 'react';
import styled from 'styled-components';
import { observer } from "mobx-react-lite";
import { FloatInputField } from '../shared/FloatInputField';
import { useTranslation } from 'react-i18next';
import { GesturePatternEditor } from './GesturePatternEditor';
import { combatStore } from '../../stores/CombatStore';
const PlayerAttackContainer = styled.div.withConfig({
  displayName: "PlayerAttacksEditor__PlayerAttackContainer",
  componentId: "sc-12si8nc-0"
})(["border-left:1px solid black;margin-left:1em;padding-left:1em;margin-top:0.5em;margin-bottom:2em;"]);
const PlayerAttack = observer(({
  playerAttack
}) => {
  const {
    t
  } = useTranslation();
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", null, playerAttack.name), /*#__PURE__*/React.createElement(PlayerAttackContainer, null, /*#__PURE__*/React.createElement("table", null, /*#__PURE__*/React.createElement("tbody", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", null, t("editor.combat_configuration_player_attack_damage"), ":"), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(FloatInputField, {
    value: playerAttack.damage,
    onChange: playerAttack.setDamage.bind(playerAttack),
    onlyPositive: true
  }))), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", null, t("editor.combat_configuration_player_attack_cooldown"), ":"), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(FloatInputField, {
    value: playerAttack.cooldown,
    onChange: playerAttack.setCooldown.bind(playerAttack),
    onlyPositive: true
  }))), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", null, t("editor.combat_configuration_player_attack_hit_animation_duration"), ":"), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(FloatInputField, {
    value: playerAttack.hitAnimationDuration,
    onChange: playerAttack.setHitAnimationDuration.bind(playerAttack),
    onlyPositive: true
  }))), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", null, t("editor.combat_configuration_gesture_pattern"), ":"), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(GesturePatternEditor, {
    gesturePattern: playerAttack.pattern,
    isGlobalPattern: false
  })))))));
});
export const PlayerAttacksEditor = observer(() => {
  const {
    t
  } = useTranslation();
  const {
    playerAttacks
  } = combatStore.config;
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h1", null, t("editor.combat_configuration_player_attacks")), playerAttacks.map(playerAttack => /*#__PURE__*/React.createElement(PlayerAttack, {
    key: playerAttack.$modelId,
    playerAttack: playerAttack
  })));
});